module.exports = __webpack_public_path__ + "img/NetworkHealth_64x64.9ceee330.png";